import { render, staticRenderFns } from "./PayoffChart.vue?vue&type=template&id=5be0b1bc&"
import script from "./PayoffChart.vue?vue&type=script&lang=js&"
export * from "./PayoffChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports